import { Component, input } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-alert-triangle',
  imports: [],
  templateUrl: './alert-triangle.html',
  styleUrl: './alert-triangle.scss',
})
export class AlertTriangle {
  stroke = input('#797674');
  width = input('1rem');
  height = input('1rem');
}